import { render, staticRenderFns } from "./InviteCodeView.vue?vue&type=template&id=0fab21b0&scoped=true"
import script from "./InviteCodeView.vue?vue&type=script&lang=js"
export * from "./InviteCodeView.vue?vue&type=script&lang=js"
import style0 from "./InviteCodeView.vue?vue&type=style&index=0&id=0fab21b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab21b0",
  null
  
)

export default component.exports